<template>
    <WaitingBlock v-if="viewState.isLoading"></WaitingBlock>
    <table v-else>
        <thead>
            <tr>
                <th>#</th>
                <th>Time</th>
                <th>Name</th>
                <th>Description</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(contentLine, index) in preparedContents"
                :key="contentLine.id">
                <td>{{index}}</td>
                <td>{{contentLine._start.format('HH:mm')}}</td>
                <td>
                    <span v-if="contentLine.content">
                        <span class="decorator">
                            <i class="fas fa-circle" :style="{ color: contentLine.content.colorCode }" :title="contentLine.content.name"></i>
                        </span>{{(contentLine.content || {}).name}}
                    </span>
                </td>
                <td>{{(contentLine.content ||{}).description}}</td>
            </tr>
        </tbody>
    </table>

</template>
<script>
    import Moment from 'moment'
    import { HTTP } from "@/utils/http";
    import Apis from '@/apis/index'
    import { setTimeout } from 'timers';
    import WaitingBlock from'@/components/common/WaitingBlock'

    export default {
        name: 'PlanningPodcastList',
        components: { WaitingBlock },
        computed: {
            scheduledDate() {
                return Moment(this.$route.params.planningDate);
            },
            preparedContents() {
                return ((this.planningData || {}).contents || [])
                    .filter(e => e.content.trackType !== 'PROMO')
                    .map(itm => {
                        console.log('itm: ', itm);
                        var tr = {
                            _start: Moment(itm.startTime, "HH:mm:ss"),
                        };
                        var filled = Object.assign(tr, itm)
                        return filled;
                    })
                    .sort((a, b) => a.startTime.localeCompare(b.startTime))
            }
        },
        mounted() {
            this.loadData();
        },
        beforeDestroy() {
            clearInterval(this.polling)
        },
        data() {
            return {
                viewState: {
                    isLoading: false
                },
                planningData: null,
                response: null,
            }
        },
        methods: {
            onApiLoaded(response) {
                this.planningData = response.data.dataItem
            },
            onApiError(error) {
                this.planningData = error.response.data.dataItem
            },
            onApiCompleted() {
                this.viewState.isLoading = false;
            },
            loadData() {
                console.log("reload")
                this.viewState.isLoading = true;
                HTTP.get(Apis.planning.details, {
                    params: {
                        scheduleDate: this.scheduledDate.format("YYYY-MM-DD"),
                        stationUid: this.$route.params.stationUid
                    }
                })
                    .then(this.onApiLoaded, this.onApiError)
                    .then(this.onApiCompleted);
            }
        }
    }
</script>
<style scoped>
    table {
        width: 100%;
    }

    thead, thead tr:nth-child(1) th {
        position: -webkit-sticky;
        position: sticky;
        top: 0; 
        background: white;
        border-bottom: 1px solid grey;
    }

        thead tr {
            box-shadow: 0 4px 2px -2px rgba(0,0,0,0.25);
        }

    td, th {
        padding: 15px 15px 15px 0;
        font-size: 13px;
        line-height: 16px;
    }

        th:first-child,
        td:first-child {
            padding-left: 10px;
        }

        td span {
            white-space: nowrap;
        }

            td span .decorator {
                margin-right: 10px;
            }

    th {
        color: #AAAAAA;
        padding: 22px 15px 22px 0;
    }

    tbody tr {
        color: #292C33;
        font-size: 13px;
        line-height: 16px;
        border-bottom: 1px solid #D2D2D2;
    }

    i {
        color: #D2D2D2;
    }
</style>
